
import { defineComponent } from 'vue'
import ThePagination from '@/components/Shared/ThePagination.vue'

export default defineComponent({
  components: {
    ThePagination
  },
  props: {
    loading: { type: Boolean, default: false },
    paginated: { type: Boolean, default: true }
  },
  emits: ['paginate']
})
